import {Component, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Select2Data} from '../rest-service';
import {SelectComponent} from 'ng2-select';
import {Extension, ExtensionService} from '../extension.service';
import {UserService} from '../user.service';
import {PhoneNumberService} from '../phone-number.service';
import {CallLogFilter} from '../report.service';
import * as deepEqual from 'deep-equal';
import * as moment from 'moment';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {defineLocale} from 'ngx-bootstrap/chronos';
import {ptBrLocale} from 'ngx-bootstrap/locale';
import {BsLocaleService} from 'ngx-bootstrap';
import {Department, DepartmentService} from '../department.service';
import {CostCenter, CostCenterService} from '../cost-center.service';

@Component({
  selector: 'app-call-log-filter',
  templateUrl: './call-log-filter.component.html',
  styleUrls: ['./call-log-filter.component.css']
})
export class CallLogFilterComponent implements OnInit {

  @Output() onRule = new EventEmitter<CallLogFilter>();

  @ViewChild('select_filter') selectFilter: SelectComponent;
  @ViewChild('select_operator') selectOperator: SelectComponent;
  @ViewChild('select_extension') selectExtension: SelectComponent;
  @ViewChild('select_department') selectDepartment: SelectComponent;
  @ViewChild('select_cost_center') selectCostCenter: SelectComponent;
  @ViewChild('select_phone_number') selectPhoneNumber: SelectComponent;
  @ViewChild('select_start_extension') selectStartExtension: SelectComponent;
  @ViewChild('select_end_extension') selectEndExtension: SelectComponent;
  @ViewChild('select_date') selectDate: SelectComponent;
  @ViewChild('select_call_type') selectCallType: SelectComponent;

  filterSelectData: Select2Data[] = [{id: 'extension', text: 'Ramal'}, {id: 'costCenter', text: 'Centro de custo'},
    {id: 'department', text: 'Departamento'}, {id: 'destination', text: 'Destino'}, {id: 'source', text: 'Origem'}];

  operatorSelectData: Select2Data[] = [{id: 'equal', text: 'igual a'}, {id: 'between', text: 'entre'}];

  extensionOperatorSelectData: Select2Data[] = [{id: 'equal', text: 'igual a'}, {id: 'between', text: 'entre'}];
  equalOnlyOperatorSelectData: Select2Data[] = [{id: 'equal', text: 'igual a'}];
  destinationOrSourceOperatorSelectData: Select2Data[] = [{id: 'equal', text: 'igual a'}, {id: 'contains', text: 'contém'}];

  dateSelectData: Select2Data[] = [{id: 'today', text: 'Hoje'}, {id: 'yesterday', text: 'Desde Ontem'},
    {id: 'actual_week', text: 'Semana Atual'}, {id: 'actual_month', text: 'Mês Atual'}, {id: 'past_week', text: 'Semana Passada'},
    {id: 'past_month', text: 'Mês Passado'}, {id: 'select', text: 'Selecionar'}];

  callTypeSelectData: Select2Data[] = [{id: 'all', text: 'Todos'}, {id: 'INCOMING', text: 'Entrada'},
    {id: 'OUTGOING', text: 'Saída'}, {id: 'INTERNAL', text: 'Interna'}, {id: 'UNKNOWN', text: 'Desconhecido'}];

  extensions: Extension[];
  extensionSelectData: Select2Data[];

  departments: Department[];
  departmentSelectData: Select2Data[];

  costCenters: CostCenter[];
  costCenterSelectData: Select2Data[];

  rules = new BehaviorSubject<string[][]>([]);

  filterFormConfig = {
    'filterType': ['', Validators.required],
    'operator': ['', Validators.required],
    'extension': [''],
    'department': [''],
    'costCenter': [''],
    'phoneNumber': [''],
    'startExtension': [''],
    'endExtension': [''],
    'filterDate': [''],
    'callType': [''],
    'dateSelection': [''],
  };

  filterForm: FormGroup;

  disableOperatorSelection = true;
  enableExtensionSelection = false;
  enableDepartmentSelection = false;
  enableCostCenterSelection = false;
  enablePhoneNumber = false;

  enableExtensionBetweenSelection = false;

  enableDateRangeSelection = false;

  ruleInvalid = true;

  constructor(private fb: FormBuilder, private us: UserService, private es: ExtensionService, private ds: DepartmentService,
              private ccs: CostCenterService, private localeService: BsLocaleService) {
    this.filterForm = this.fb.group(this.filterFormConfig);
    es.getAllByCustomerId(us.currentUser.getValue().customerDatabaseId).subscribe(extensions => {
      this.extensions = extensions;
      this.extensions.sort((a, b) => a.number.getLDFormat() > b.number.getLDFormat() ? 1 : -1)
      this.extensionSelectData = extensions.map(extension => {
        return {id: extension.number.getCleanE164Format(), text: extension.number.getPrettyLDFormat()}
      });
    });
    ds.getAllByCustomerId(us.currentUser.getValue().customerDatabaseId).subscribe(departments => {
      this.departments = departments;
      this.departmentSelectData = departments.map(department => {
        return {id: department.id, text: department.description}
      });
    });
    ccs.getAllByCustomerId(us.currentUser.getValue().customerDatabaseId).subscribe(costCenters => {
      this.costCenters = costCenters;
      this.costCenterSelectData = costCenters.map(costCenter => {
        return {id: costCenter.id, text: costCenter.description}
      });
    });
    this.filterForm.get('filterType').valueChanges.subscribe((value) => {
      if (value === 'extension') {
        this.operatorSelectData = this.extensionOperatorSelectData;
      } else if (value === 'department' || value === 'costCenter') {
        this.operatorSelectData = this.equalOnlyOperatorSelectData;
      } else if (value === 'destination') {
        this.operatorSelectData = this.destinationOrSourceOperatorSelectData;
      } else if (value === 'source') {
        this.operatorSelectData = this.destinationOrSourceOperatorSelectData;
      }
    });
  }

  ngOnInit() {
    defineLocale('pt-br', ptBrLocale);
    this.localeService.use('pt-br');
    this.rules.subscribe(rules => this.onRule.emit(new CallLogFilter(rules)));
    this.filterForm.valueChanges.debounceTime(250).subscribe(data => {
      this.updateFilterRules();
    });
    this.setFilterDate(this.dateSelectData[0]);
  }

  cleanFilterForm() {
    this.filterForm.get('filterType').setValue(undefined);
    this.filterForm.get('filterType').markAsPristine();
    this.selectFilter.active = [];

    this.filterForm.get('operator').setValue(undefined);
    this.filterForm.get('operator').markAsPristine();
    this.selectOperator.active = [];

    this.filterForm.get('phoneNumber').setValue(undefined);
    this.filterForm.get('phoneNumber').markAsPristine();

    this.filterForm.get('callType').patchValue('all');
    this.selectCallType.active = [this.callTypeSelectData[0]];
    this.selectDate.active = [this.dateSelectData[0]];


    this.updateFilterRules();
  }

  addRule(data: any) {
    const rules = this.rules.getValue();
    if (data.filterType === 'extension') {
      if (data.operator === 'equal') {
        let extensions = '';
        if (data.extension.length === 1) {
          extensions = data.extension[0].id;
        } else {
          data.extension.forEach((value, index) => {
            if (index !== 0) {
              extensions += ',';
            }
            extensions += value.id;
          })
        }
        rules.push(['extension', 'equal', extensions]);
      } else if (data.operator === 'between') {
        rules.push(['extension', 'between', data.startExtension.id, data.endExtension.id])
      }
    } else if (data.filterType === 'department') {
      if (data.operator === 'equal') {
        let departments = '';
        if (data.department.length === 1) {
          departments = data.department[0].id;
        } else {
          data.department.forEach((value, index) => {
            if (index !== 0) {
              departments += ',';
            }
            departments += value.id;
          })
        }
        rules.push(['department', 'equal', departments]);
      }
    } else if (data.filterType === 'costCenter') {
      if (data.operator === 'equal') {
        let costCenters = '';
        if (data.costCenter.length === 1) {
          costCenters = data.costCenter[0].id;
        } else {
          data.costCenter.forEach((value, index) => {
            if (index !== 0) {
              costCenters += ',';
            }
            costCenters += value.id;
          })
        }
        rules.push(['cost_center', 'equal', costCenters]);
      }
    } else if (data.filterType === 'destination' || data.filterType === 'source') {
      if (data.operator === 'equal') {
        // console.log(`phone(${data.phoneNumber}): ${PhoneNumberService.parse(data.phoneNumber)}`);
        const destination = PhoneNumberService.parse(data.phoneNumber).getCleanE164Format();
        rules.push([data.filterType, 'equal', destination]);
      } else if (data.operator === 'between') {
        rules.push([data.filterType, 'between', data.startExtension.id, data.endExtension.id])
      } else if (data.operator === 'contains') {
        rules.push([data.filterType, 'contains', PhoneNumberService.stripNonPhoneNumberDigits(data.phoneNumber)])
      }
    }
    this.cleanFilterForm();
    console.log(`rules: ${JSON.stringify(rules)}`);
    this.rules.next(rules);
  }

  updateFilterRules() {
    // console.log(`updating rules...`);
    this.disableOperatorSelection = true;
    this.enableExtensionSelection = false;
    this.enableDepartmentSelection = false;
    this.enableCostCenterSelection = false;
    this.enableExtensionBetweenSelection = false;
    this.enablePhoneNumber = false;
    this.ruleInvalid = true;

    const filterType = this.filterForm.get('filterType').value;
    if (filterType === 'extension') {
      this.disableOperatorSelection = false;
      if (this.selectOperator.active.length !== 0) {
        if (this.selectOperator.active[0].id === 'equal') {
          this.enableExtensionSelection = true;
          if (this.selectExtension && this.selectExtension.active.length > 0) {
            this.ruleInvalid = false;
          }
        } else if (this.selectOperator.active[0].id === 'between') {
          this.enableExtensionBetweenSelection = true;
          if (this.selectStartExtension && this.selectStartExtension.active.length > 0 &&
            this.selectEndExtension && this.selectEndExtension.active.length > 0) {
            if (this.filterForm.get('endExtension').value.id > this.filterForm.get('startExtension').value.id) {
              this.ruleInvalid = false;
            }
          }
        } else {
          this.enableExtensionSelection = false;
        }
      }
    } else if (filterType === 'department') {
      this.disableOperatorSelection = false;
      if (this.selectOperator.active.length !== 0) {
        if (this.selectOperator.active[0].id === 'equal') {
          this.enableDepartmentSelection = true;
          if (this.selectDepartment && this.selectDepartment.active.length > 0) {
            this.ruleInvalid = false;
          }
        } else {
          this.enableDepartmentSelection = false;
        }
      }
    } else if (filterType === 'costCenter') {
      this.disableOperatorSelection = false;
      if (this.selectOperator.active.length !== 0) {
        if (this.selectOperator.active[0].id === 'equal') {
          this.enableCostCenterSelection = true;
          if (this.selectCostCenter && this.selectCostCenter.active.length > 0) {
            this.ruleInvalid = false;
          }
        } else {
          this.enableCostCenterSelection = false;
        }
      }
    } else if (filterType === 'destination' || filterType === 'source') {
      this.disableOperatorSelection = false;
      if (this.selectOperator.active.length !== 0) {
        if (this.selectOperator.active[0].id === 'equal') {
          this.enablePhoneNumber = true;
          const phone = PhoneNumberService.parse(this.filterForm.get('phoneNumber').value);
          if (this.enablePhoneNumber && phone) {
            this.ruleInvalid = false;
          }
        } else if (this.selectOperator.active[0].id === 'contains') {
          this.enablePhoneNumber = true;
          const phone = PhoneNumberService.stripNonPhoneNumberDigits(this.filterForm.get('phoneNumber').value);
          if (this.enablePhoneNumber && phone !== '') {
            this.ruleInvalid = false;
          }
        } else {
          this.enablePhoneNumber = false;
        }
      }
    }
    const filterDate = this.filterForm.get('filterDate').value;
    if (filterDate !== 'select') {
      this.enableDateRangeSelection = false;
      const rule = this.calculateDateRule(filterDate, new Date());
      this.updateSingleRule(rule);
    } else {
      this.enableDateRangeSelection = true;
      const dateRangeSelected: Date[] = this.filterForm.get('dateSelection').value;
      if (dateRangeSelected) {
        const rule = ['date', 'between', `${moment(dateRangeSelected[0]).format('YYYY-MM-DD')} 00:00:00`,
          `${moment(dateRangeSelected[1]).format('YYYY-MM-DD')} 23:59:59`];
        this.updateSingleRule(rule);
      }
    }
    const callType = this.filterForm.get('callType').value;
    if (callType !== 'all' && callType !== '' && callType !== null) {
      console.log(`calltype updated to ${callType}`)
      this.updateSingleRule(['call_type', 'equal', callType]);
    } else {
      this.removeRulesOfType('call_type');
    }
  }

  updateSingleRule(rule: string[]) {
    let rules = this.rules.getValue();
    const actualRule = rules.find(value => value[0] === rule[0]);
    if (actualRule) {
      if (!deepEqual(rule, actualRule)) {
        rules = rules.filter(value => value[0] !== rule[0]);
        rules.push(rule);
        this.rules.next(rules);
      }
    } else {
      rules.push(rule);
      this.rules.next(rules);
    }
  }

  removeRulesOfType(type: string) {
    let actualRules = this.rules.getValue();
    actualRules = actualRules.filter(value => value[0] !== type);
    this.rules.next(actualRules);
  }

  calculateDateRule(filterDate: string, startDate: Date): string[] {
    if (filterDate === 'today') {
      return ['date', 'greater_than', `${moment(startDate)
        .format('YYYY-MM-DD')} 00:00:00`];
    } else if (filterDate === 'yesterday') {
      return ['date', 'greater_than', `${moment(startDate).subtract(1, 'days')
        .format('YYYY-MM-DD')} 00:00:00`];
    } else if (filterDate === 'last_7_days') {
      return ['date', 'greater_than', `${moment(startDate).subtract(7, 'days')
        .format('YYYY-MM-DD')} 00:00:00`];
    } else if (filterDate === 'last_30_days') {
      return ['date', 'greater_than', `${moment(startDate).subtract(30, 'days')
        .format('YYYY-MM-DD')} 00:00:00`];
    } else if (filterDate === 'actual_week') {
      return ['date', 'between',
        `${moment(startDate).startOf('week').format('YYYY-MM-DD')} 00:00:00`,
        `${moment(startDate).endOf('week').format('YYYY-MM-DD')} 23:59:59`];
    } else if (filterDate === 'actual_month') {
      return ['date', 'between',
        `${moment(startDate).startOf('month').format('YYYY-MM-DD')} 00:00:00`,
        `${moment(startDate).endOf('month').format('YYYY-MM-DD')} 23:59:59`];
    } else if (filterDate === 'past_week') {
      return ['date', 'between',
        `${moment(startDate).startOf('week').subtract(7, 'days').format('YYYY-MM-DD')} 00:00:00`,
        `${moment(startDate).endOf('week').subtract(7, 'days').format('YYYY-MM-DD')} 23:59:59`];
    } else if (filterDate === 'past_month') {
      return ['date', 'between',
        `${moment(startDate).subtract(1, 'month').startOf('month').format('YYYY-MM-DD')} 00:00:00`,
        `${moment(startDate).subtract(1, 'month').endOf('month').format('YYYY-MM-DD')} 23:59:59`];
    }
    return ['date', 'greater_than', `${moment(startDate).format('YYYY-MM-DD')} 00:00:00`];
  }

  setFilterType(data: Select2Data) {
    this.filterForm.get('filterType').patchValue(data.id);
  }

  setOperator(data: Select2Data) {
    this.filterForm.get('operator').patchValue(data.id);
  }

  setExtension(data: Select2Data[]) {
    this.filterForm.get('extension').patchValue(data);
  }

  setStartExtension(data: Select2Data) {
    this.filterForm.get('startExtension').patchValue(data);
  }

  setEndExtension(data: Select2Data) {
    this.filterForm.get('endExtension').patchValue(data);
  }

  setDepartment(data: Select2Data[]) {
    this.filterForm.get('department').patchValue(data);
  }

  setCostCenter(data: Select2Data[]) {
    this.filterForm.get('costCenter').patchValue(data);
  }

  setFilterDate(data: Select2Data) {
    this.filterForm.get('filterDate').patchValue(data.id);
  }

  setCallType(data: Select2Data) {
    this.filterForm.get('callType').patchValue(data.id);
  }

  removeRule(index: number) {
    const rules = this.rules.getValue();
    rules.splice(index, 1);
    this.rules.next(rules);
  }

  convertRuleToText(rule: string[]): string {
    let result = '';
    if (rule[0] === 'extension') {
      result += 'RAMAL ';
      if (rule[1] === 'equal') {
        result += 'igual a ';
        rule[2].split(',').forEach((value, index) => {
          if (index !== 0) {
            result += ', ';
          }
          const phone = PhoneNumberService.parse(value);
          result += phone.getLocalFormat();
        });
      } else if (rule[1] === 'between') {
        result += 'entre ';
        const startExtension = PhoneNumberService.parse(rule[2]);
        const endExtension = PhoneNumberService.parse(rule[3]);
        result += startExtension.getLocalFormat();
        result += ' e ';
        result += endExtension.getLocalFormat();
      }
    } else if (rule[0] === 'department') {
      result += 'DEPARTMENTO ';
      if (rule[1] === 'equal') {
        result += 'igual a ';
        rule[2].split(',').forEach((value, index) => {
          if (index !== 0) {
            result += ', ';
          }
          const department = this.departments.find(dep => dep.id === value);
          result += department.description;
        });
      }
    } else if (rule[0] === 'cost_center') {
      result += 'CENTRO DE CUSTO ';
      if (rule[1] === 'equal') {
        result += 'igual a ';
        rule[2].split(',').forEach((value, index) => {
          if (index !== 0) {
            result += ', ';
          }
          const costCenter = this.costCenters.find(cc => cc.id === value);
          result += costCenter.description;
        });
      }
    } else if (rule[0] === 'destination' || rule[0] === 'source') {
      if (rule[0] === 'destination') {
        result += 'DESTINO ';
      } else {
        result += 'ORIGEM ';
      }
      if (rule[1] === 'equal') {
        result += 'igual a ';
        rule[2].split(',').forEach((value, index) => {
          if (index !== 0) {
            result += ', ';
          }
          const phone = PhoneNumberService.parse(value);
          result += phone.getLocalFormat();
        });
      } else if (rule[1] === 'contains') {
        result += 'contém ';
        rule[2].split(',').forEach((value, index) => {
          if (index !== 0) {
            result += ', ';
          }
          result += value;
        });
      } else if (rule[1] === 'between') {
        result += 'entre ';
        const startExtension = PhoneNumberService.parse(rule[2]);
        const endExtension = PhoneNumberService.parse(rule[3]);
        result += startExtension.getLocalFormat();
        result += ' e ';
        result += endExtension.getLocalFormat();
      }
    } else if (rule[0] === 'date') {
      result += 'DATA ';
      if (rule[1] === 'greater_than') {
        result += 'maior ou igual à ';
        result += this.convertToDate(rule[2]);
      } else if (rule[1] === 'between') {
        result += 'entre ';
        result += `${this.convertToDate(rule[2])} e ${this.convertToDate(rule[3])}`;
      }
    } else if (rule[0] === 'call_type') {
      result += 'TIPO DE CHAMADA ';
      result += 'igual a ';
      if (rule[2] === 'INCOMING') {
        result += 'ENTRADA';
      } else if (rule[2] === 'OUTGOING') {
        result += 'SAIDA';
      } else if (rule[2] === 'INTERNAL') {
        result += 'INTERNA';
      } else if (rule[2] === 'UNKNOWN') {
        result += 'DESCONHECIDA';
      }
    }
    return result;
  }

  convertToDate(dateString): string {
    return `${dateString.substr(8, 2)}/${dateString.substr(5, 2)}/${dateString.substr(0, 4)}`
  }

  isDismissible(rule: string[]): boolean {
    if (rule.length === 0) {
      return false;
    }
    const dismissible: Array<string> = ['extension', 'department', 'cost_center', 'destination', 'source'];
    if (dismissible.some(x => x === rule[0])) {
      return true
    } else {
      return false;
    }
  }
}



// WEBPACK FOOTER //
// /Users/tabelini/development/jvm/tenacity/pysix/PysixCloud/src/app/call-log-filter/call-log-filter.component.ts